import { DiscountType } from '@app-types/discount';
import { PriceType } from '@app-types/price';
import { PriceFundingsDetails } from '@app-types/product';

import { MarketingType, PlanTypeId } from '@constants/plan';

export const SimoSubCategories = [PlanTypeId.SIMO_ENTRY, PlanTypeId.SIMO_MULTILIGNE];
export const PremiumSubCategories = [
    PlanTypeId.PREMIUM_SELECTION,
    PlanTypeId.PREMIUM_ENTRY,
    PlanTypeId.PREMIUM_MULTILIGNE,
];
export const ProSimoSubCategories = [PlanTypeId.SIMO_PRO_SELECTION];
export const ProPremiumSubCategories = [PlanTypeId.PREMIUM_PRO_SELECTION];

export function getPricesWithPromos(offerPriceDetails: PriceFundingsDetails): PriceType {
    const priceInitial = offerPriceDetails?.price?.initial || 0;
    const promos = offerPriceDetails?.discounts || [];
    const prices: PriceType = {
        initial: priceInitial || 0,
        subsidized: priceInitial || 0,
        forever: priceInitial || 0,
        foreverWithoutBig: priceInitial || 0,
        final: priceInitial || 0,
    };

    const { basePromos, portabilityPromo, additionalDiscounts } = getPromoAmountByType(promos);

    prices.initial = round2(prices.initial - basePromos - portabilityPromo);
    prices.final = round2(prices.final - basePromos - portabilityPromo - additionalDiscounts);
    prices.forever = round2(prices.forever - basePromos - additionalDiscounts);

    prices.duration = Math.max(...promos.map((promo) => promo.duration || 0));

    if (prices.forever && prices.final.toFixed(2) === prices.forever.toFixed(2)) {
        prices.duration = 0;
    }

    const discountBig = promos.find(
        (promo) => promo.marketingTypes.includes(MarketingType.HOME) && !promo.isIncitation,
    );
    prices.foreverWithoutBig = round2(prices.forever + (discountBig?.value ?? 0));

    return prices;
}

function getPromoAmountByType(discounts: DiscountType[]) {
    return discounts.reduce(
        (acc, promo) => {
            const isPortability = promo.marketingTypes.includes(MarketingType.PORTABILITY);
            const isHome = promo.marketingTypes.includes(MarketingType.HOME);
            const isMultiline = promo.marketingTypes.includes(MarketingType.MULTILINE);

            if (!isPortability && !isHome && !isMultiline) {
                acc.basePromos += promo.value;
            }
            if (isPortability) {
                acc.portabilityPromo += promo.value;
            }
            if (isMultiline) {
                acc.additionalDiscounts += promo.value;
            }
            if (isHome && !promo.isIncitation) {
                acc.additionalDiscounts += promo.value;
            }
            return acc;
        },
        { basePromos: 0, portabilityPromo: 0, additionalDiscounts: 0 },
    );
}

const round2 = (value: number) => Math.round(value * 100) / 100;
